import { render } from "./natureEventClub.vue?vue&type=template&id=2ca86ac6"
import script from "./natureEventClub.vue?vue&type=script&lang=js"
export * from "./natureEventClub.vue?vue&type=script&lang=js"

import "./natureEventClub.vue?vue&type=style&index=0&id=2ca86ac6&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__